module.exports = {
  FILTER_ON_ITEMS_CHECKED: "FILTER_ON_ITEMS_CHECKED",
  ONLY_SHOW_ITEMS_CHECKED: "ONLY_SHOW_ITEMS_CHECKED",
  ONLY_SHOW_ITEMS_WITH_CHECKED: "ONLY_SHOW_ITEMS_WITH_CHECKED",
  FILTER_ON_IMPC_CHECKED: "FILTER_ON_IMPC_CHECKED",
  FILTER_ON_DESPATCH_CHECKED: "FILTER_ON_DESPATCH_CHECKED",
  MANUAL_ENTRY: "MANUAL_ENTRY",
  SPACE_SEPERATED_SUFFIXES: "SPACE_SEPERATED_SUFFIXES",
};
